import React from 'react'

const Footer = () => {
  return (
    <footer className='footer'>
        <div>
            <h1>ImaginAI</h1>
            <p>@ all ©️ rights reserved</p>
        </div>

        <div>
            <h5>Follow us</h5>
            <div>
                <a href="https://www.instagram.com/ankit_porwal04" target={"blank"}>Instagram</a>
                <a href="https://www.twitter.com/AnkitPorwal04" target={"blank"}>Twitter</a>
                <a href="https://www.linkedin.com/in/ankitporwal04" target={"blank"}>LinkedIn</a>
                <a href="https://www.github.com/AnkitPorwal04" target={"blank"}>GitHub</a>
            </div>
        </div>
    </footer>
  )
}

export default Footer